export default __webpack_public_path__ + "static/media/lottery-banners-bm.fd0bb552.webp";